var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCreatePollMenu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.94,
    height: 17.739,
    viewBox: "0 0 20.94 17.739",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1177",
    "data-name": "Group 1177",
    transform: "translate(-22.024 -33.366)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1392",
    "data-name": "Path 1392",
    d: "M141.175,86.529a.982.982,0,0,1,1.04-.669c.924.018,1.849,0,2.773.006.735,0,1.024.321,1.024,1.135q0,4.181,0,8.363c0,.843-.268,1.132-1.042,1.132-.915,0-1.831-.021-2.745.009a.988.988,0,0,1-1.051-.643Z",
    transform: "translate(-103.049 -45.4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1393",
    "data-name": "Path 1393",
    d: "M86.482,42.237q0,3.949,0,7.9c0,.672-.287.959-.965.961-.934,0-1.869-.024-2.8.008-.792.027-1.078-.379-1.076-1.068.012-4.7.006-9.4.006-14.1,0-.538,0-1.076,0-1.614a.843.843,0,0,1,.956-.957q1.472,0,2.944,0a.831.831,0,0,1,.935.943Q86.483,38.273,86.482,42.237Z",
    transform: "translate(-51.559)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1394",
    "data-name": "Path 1394",
    d: "M26.878,75.672q0,2.731,0,5.462c0,.672-.295.972-.958.974q-1.471,0-2.943,0a.835.835,0,0,1-.95-.957q0-5.49,0-10.98a.835.835,0,0,1,.934-.95q1.5-.01,3,0a.827.827,0,0,1,.918.933Q26.879,72.913,26.878,75.672Z",
    transform: "translate(0 -31.004)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreatePollMenu);
export default __webpack_public_path__ + "static/media/Create_Poll_Menu.3a4bfff007cab0b032d289ee5c2ffdd0.svg";
export { ForwardRef as ReactComponent };